var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 5L5 19M5 5L19 19","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
